import ContentTemplateDeviceGroupsTab from './ContentTemplateDeviceGroupsTab';

export default ContentTemplateDeviceGroupsTab;
